// ========================================
// ================== V3 ==================
// ========================================

import { Auth } from "aws-amplify";
import { call, put } from 'redux-saga/effects';


// export function* refreshTokenSaga() {
//   const cognitoUser = yield Auth.currentAuthenticatedUser();
//   const currentSession = yield Auth.currentSession();
//   yield cognitoUser.refreshSession(currentSession.refreshToken);
//   return cognitoUser;
// }

export function* refreshTokenSaga() {
  try {
    const user = yield call([Auth, Auth.currentAuthenticatedUser]);
    const session = yield call([Auth, Auth.currentSession]);

    if (!session.isValid()) {
      throw new Error("Sessão inválida.");
      // window.location.href = "/login";
    }

    const newSession = yield call(() =>
      new Promise((resolve, reject) => {
        user.refreshSession(session.getRefreshToken(), (err, session) => {
          if (err) reject(err);
          else resolve(session);
        });
      })
    );

    // console.log("Sessão renovada com sucesso:", newSession);
    // window.location.href = "/login";
    return newSession;

  } catch (error) {
    console.log("Erro ao atualizar token:", error);

    // Redireciona ou despacha logout
    // window.location.href = "/login"; // ou yield put(logoutAction());

    // Você pode despachar uma ação de logout aqui também se quiser
    // yield put({ type: 'LOGOUT' });
  }
}

